import React, { useEffect, useState } from 'react';
import './Projects.css';
import { Project } from '../types';
import { getProjects } from '../queries/getProjects';

// Import all the necessary local icon components
import ReactIcon from './icons/ReactIcon';
import NodeJsIcon from './icons/NodeJsIcon';
import AwsIcon from './icons/AwsIcon';
import PostgresqlIcon from './icons/PostgresqlIcon';
import MongodbIcon from './icons/MongodbIcon';
import DockerIcon from './icons/DockerIcon';
import JavaIcon from './icons/JavaIcon';
import GithubIcon from './icons/GithubIcon';
// etc.

const techIcons: { [key: string]: React.ComponentType } = {
  "React": ReactIcon,
  "Node.js": NodeJsIcon,
  "AWS": AwsIcon,
  "PostgreSQL": PostgresqlIcon,
  "MongoDB": MongodbIcon,
  "Docker": DockerIcon,
  "Java": JavaIcon,
  "GitHub": GithubIcon,
  // ...
};

const Projects: React.FC = () => {
  const [projects, setProjects] = useState<Project[]>([]);

  useEffect(() => {
    async function fetchProjects() {
      const data = await getProjects();
      setProjects(data);
    }
    fetchProjects();
  }, []);

  if (projects.length === 0) return <div>Loading...</div>;

  return (
    <div className="projects-container">
      <div className="projects-grid">
        {projects.map((project, index) => (
          // MODIFICATION: The card itself is now the link (<a> tag)
          <a
            key={index}
            href={project.projectlink}
            target="_blank"
            rel="noopener noreferrer"
            className="project-card" // The <a> tag is the card
            style={{ '--delay': `${index * 0.1}s` } as React.CSSProperties}
          >
            <img src={project.image.url} alt={project.title} className="project-image" />
            <div className="project-details">
              <h3>{project.title}</h3>
              <p>{project.description}</p>
              <div className="tech-used">
                {project.techused.split(', ').map((tech, i) => {
                  const IconComponent = techIcons[tech];
                  return (
                    <span key={i} className="tech-badge">
                      {IconComponent ? <IconComponent /> : "🔧"} {tech}
                    </span>
                  );
                })}
              </div>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
};

export default Projects;